module.exports = __webpack_public_path__ + "static/p4-8a22e3694daf37e5afbc39947e366837.jpg";